import { render, staticRenderFns } from "./page-wizard-technical.vue?vue&type=template&id=5cfb674b"
import script from "./page-wizard-technical.vue?vue&type=script&lang=js"
export * from "./page-wizard-technical.vue?vue&type=script&lang=js"
import style0 from "./page-wizard-technical.vue?vue&type=style&index=0&id=5cfb674b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports